import { Line } from '@ant-design/plots';
import { useEffect, useState } from 'react';
import dashboardService from '../../../services/dashboard.service';
const CertificationLineChart = () => {
  const [data, setData] = useState([]);

  const fetch = async () => {
    const data  = await dashboardService.fetchLast12Months()
    setData(data)
  }

  useEffect(() => {
      fetch();
  }, []);

  const config = {
    data,
    xField: 'month',
    yField: 'value',
    seriesField: 'type',
    smooth: true,
    tooltip: { showMarkers: true },
    xAxis: {
      title: { text: 'Mes' },
      label: {
        formatter: (val) => {
          const [year, month] = val.split('-');
          return `${month}/${year.slice(2)}`;
        },
      },
    },
    yAxis: {
      title: { text: 'Cantidad' },
    },
    legend: { position: 'top' },
  };

  return <Line {...config} />;
};

export default CertificationLineChart;
